import {
  TERMINATION_LOADING,
  GET_TERMINATION,
  GET_TERMINATION_SUCCESS,
  GET_TERMINATION_FAIL,
  ADD_TERMINATION_SUCCESS,
  ADD_TERMINATION_FAIL,
  DELETE_TERMINATION_SUCCESS,
  DELETE_TERMINATION_FAIL,
  UPDATE_TERMINATION_SUCCESS,
  UPDATE_TERMINATION_FAIL,
  TERMINATION_RESET
} from "./actionType";

const INIT_STATE = {
  terminations: [],
  error: {},
};

const Termination = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TERMINATION_SUCCESS:
      switch (action.payload.actionType) {
        case GET_TERMINATION:
          return {
            ...state,
            terminations: action.payload.data,
            isTerminationCreated: false,
            isTerminationSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_TERMINATION_FAIL:
      switch (action.payload.actionType) {
        case GET_TERMINATION_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isTerminationCreated: false,
            isTerminationSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_TERMINATION: {
      return {
        ...state,
        isTerminationCreated: false,
        loading: true,
      };
    }

    case TERMINATION_LOADING: {
      return {
        ...state,
        isTerminationCreated: false,
        loading: true,
      };
    }

    case ADD_TERMINATION_SUCCESS:
      return {
        ...state,
        isTerminationCreated: true,
        loading: false,
        terminations: [action.payload.data, ...state.terminations],
      };

    case ADD_TERMINATION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_TERMINATION_SUCCESS:
      return {
        ...state,
        loading: false,
        terminations: state.terminations.filter(
          termination => termination.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_TERMINATION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_TERMINATION_SUCCESS:
      return {
        ...state,
        loading: false,
        terminations: state.terminations.map(termination =>
          termination.id.toString() === action.payload.data.id.toString() ? { ...termination, ...action.payload.data } : termination
        ),
      };

    case UPDATE_TERMINATION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case TERMINATION_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Termination;